<div @FadeIn *ngIf="isLoading" class="app-loader" [style]="getStyles()"></div>